import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import {
    HELPDESK_LISTING,
    USER_DROPDOWN,
    APPROVER_DROPDOWN,
    SAVE_USER_CONFIG,
    UPDATE_USER_CONFIG,
    GET_AUTOFILL_DATA,
    USER_CONFIG_STATUS,
    USE_CASES,
    USER_REQUEST,
    USER_REQUEST_LIST,
    APPROVAL_PENDING_LIST,
    REQUEST_BY_ID,
    APPROVAL,
    BACK_TO_MODIFICATION_REQUEST, BACK_TO_MODIFICATION_RESPONSE, REQUEST_FILTER,
    FINANCE_HIERARCHY_LISTING, BACK_TO_MODIFICATION_REQUEST_LIST, CSV_DOWNLOAD
} from "./type";


export const userHelpdeskListing = (page=1, filterData=null) => async (dispatch) => {
    try {

        let url = `${Config.helpdeskUser.userHelpdeskListing}?page=${page}`
        if(filterData !== null && Object.keys(filterData).length > 0){
            url = `${Config.helpdeskUser.userHelpdeskListing}?page=${page}&user_id=${filterData?.user_id}&L1=${filterData?.L1}&L2=${filterData?.L2}`
        }

        const res = await callWebService(
            callTypes.get,
            {},
            url
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: HELPDESK_LISTING,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: HELPDESK_LISTING,
            payload: null,
        });
        return true;
    }
}

export const userdropdown = (isEdit = false) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.helpdeskUser.userDropdown}?is_edit=${isEdit}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: USER_DROPDOWN,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: HELPDESK_LISTING,
            payload: null,
        });
        return true;
    }
}

export const approverdropdown = (userId) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.helpdeskUser.approvalDropdown}?user_id=${userId}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: APPROVER_DROPDOWN,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: APPROVER_DROPDOWN,
            payload: null,
        });
        return true;
    }
}

export const saveuserConfig = (userId) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.helpdeskUser.saveUserConfig}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: SAVE_USER_CONFIG,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: SAVE_USER_CONFIG,
            payload: null,
        });
        return true;
    }
}

export const updateUserConfig = (userId,) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.helpdeskUser.updateUserConfig}?user_id=${userId}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: UPDATE_USER_CONFIG,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: UPDATE_USER_CONFIG,
            payload: null,
        });
        return true;
    }
}

export const getUserData = (configId) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.helpdeskUser.getAutofillData}?config_id=${configId}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: GET_AUTOFILL_DATA,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: GET_AUTOFILL_DATA,
            payload: null,
        });
        return true;
    }
}

export const getAutofillUserData = (configId) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.helpdeskUser.getAutofillUserData}?config_id=${configId}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: GET_AUTOFILL_DATA,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: GET_AUTOFILL_DATA,
            payload: null,
        });
        return true;
    }
}

export const userconfigStatus = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.helpdeskUser.userConfigStatus}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: USER_CONFIG_STATUS,
                payload: data?.response,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: USER_CONFIG_STATUS,
            payload: null,
        });
        return true;
    }
}


// userconfigurationStatus

export const userconfigurationStatus = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.helpdeskUser.userConfigurationStatus}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: USER_CONFIG_STATUS,
                payload: data?.response,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: USER_CONFIG_STATUS,
            payload: null,
        });
        return true;
    }
}

export const getUseCase = () => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.helpdeskUser.useCases}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: USE_CASES,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: USE_CASES,
            payload: null,
        });
        return true;
    }
}

export const userRequest = (data) => async (dispatch) => {
    try {
        setTimeout(() => {
            dispatch({
                type: USER_REQUEST,
                payload: null,
            });
        }, 500)
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.helpdeskUser.userRequest}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: USER_REQUEST,
                payload: data?.response,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: USER_REQUEST,
            payload: null,
        });
        return true;
    }
}

export const clearUserRequest = () => (dispatch) => {
    dispatch({
        type: USER_REQUEST,
        payload: null,
    });
};

export const reconPiTiValidation = (invoiceNumbers = [], { isPi = false, isTi = true } = {}) => async () => {
    try {
        const res = await callWebService(
            callTypes.post,
            {
                invoice_numbers: invoiceNumbers,
                is_pi: isPi,
                is_ti: isTi,
            },
            `${Config.helpdeskUser.reconPiTiValidation}`
        );

        if (res) {
            const { data } = res;
            const body = data?.response ?? data ?? {};
            // mrf_dropdown sits on the flat v2 envelope; normalizeApiEnvelope only
            // copies `data` into `response`, so read top-level as fallback.
            return {
                status: body?.status ?? data?.status ?? data?.status_code,
                message: body?.msg ?? body?.message ?? data?.msg ?? data?.message,
                data: body?.data ?? data?.data ?? null,
                mrfDropdown: body?.mrf_dropdown ?? data?.mrf_dropdown ?? [],
            };
        }
        return null;
    }
    catch (error) {
        return { status: 0, message: error?.message, data: null, mrfDropdown: [] };
    }
};

export const userRequestList = (page = 1) => async (dispatch) => {
    try {

        setTimeout(() => {
            dispatch({
                type: USER_REQUEST_LIST,
                payload: null,
            });
        }, 500)
        const res = await callWebService(
            callTypes.get,
            '',
            `${Config.helpdeskUser.userRequestList}?page=${page}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: USER_REQUEST_LIST,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: USER_REQUEST_LIST,
            payload: null,
        });
        return true;
    }
}

export const userRequestPendingList = (status ,page = 1, filterData = null) => async (dispatch) => {
    try {

        dispatch({
            type: APPROVAL_PENDING_LIST,
            payload: [],
        });

        let roleId = localStorage.getItem("fusion-role");
        let url = `${Config.helpdeskUser.approvalPendingList}?page=${page}&status=${status}&role_id=${roleId}`
        if(filterData !== null && Object.keys(filterData).length > 0){
            url = `${Config.helpdeskUser.approvalPendingList}?page=${page}&role_id=${roleId}&status=${filterData?.status !== '' ? filterData?.status : status}&use_case_id=${filterData?.use_case_id}&request_id=${filterData?.request_id}&pi_no=${filterData?.pi_no}&ti_no=${filterData?.ti_no}&date=${filterData?.date}&requested_name=${filterData?.requested_name}&approver_l1=${filterData?.approver_l1}&approver_l2=${filterData?.approver_l2}&department_name=${filterData?.department_name}&designation_name=${filterData?.designation_name}`
        }

        const res = await callWebService(
            callTypes.get,
            {},
            url
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: APPROVAL_PENDING_LIST,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: APPROVAL_PENDING_LIST,
            payload: null,
        });
        return true;
    }
}

export const userRequestById = (id) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            '',
            `${Config.helpdeskUser.RequestById}?id=${id}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: REQUEST_BY_ID,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: REQUEST_BY_ID,
            payload: null,
        });
        return true;
    }
}

export const approval = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.helpdeskUser.Approval}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: APPROVAL,
                payload: data?.response,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: APPROVAL,
            payload: null,
        });
        return true;
    }
}

export const backToModificationRequest = (data) => async (dispatch) => {
    try {
        setTimeout(() => {
            dispatch({
                type: BACK_TO_MODIFICATION_REQUEST,
                payload: null,
            });
        }, 1000)

        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.helpdeskUser.backToModification}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: BACK_TO_MODIFICATION_REQUEST,
                payload: data?.response,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: BACK_TO_MODIFICATION_REQUEST,
            payload: null,
        });
        return true;
    }
}

export const backToModificationResponse = (data) => async (dispatch) => {
    try {
        setTimeout(() => {
            dispatch({
                type: BACK_TO_MODIFICATION_REQUEST,
                payload: null,
            });
        }, 1000)
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.helpdeskUser.backToModificationResponse}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: BACK_TO_MODIFICATION_RESPONSE,
                payload: data?.response,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: BACK_TO_MODIFICATION_RESPONSE,
            payload: null,
        });
        return true;
    }
}

export const userRequestFilter = () => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            '',
            `${Config.helpdeskUser.requestFilterData}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: REQUEST_FILTER,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: REQUEST_FILTER,
            payload: null,
        });
        return true;
    }
}


export const saveUserConfiguration = (userId) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.helpdeskUser.saveUserConfiguration}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: SAVE_USER_CONFIG,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: SAVE_USER_CONFIG,
            payload: null,
        });
        return true;
    }
}

export const userConfigListing = (page=1, filterData=null) => async (dispatch) => {
    dispatch({
        type: GET_AUTOFILL_DATA,
        payload: null,
    });
    try {

        let url = `${Config.helpdeskUser.userConfigListing}?page=${page}`
        if(filterData !== null && Object.keys(filterData).length > 0){
            url = `${Config.helpdeskUser.userConfigListing}?page=${page}&user_id=${filterData?.user_id}&L1=${filterData?.L1}&L2=${filterData?.L2}`
        }

        const res = await callWebService(
            callTypes.get,
            {},
            url
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: HELPDESK_LISTING,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: HELPDESK_LISTING,
            payload: null,
        });
        return true;
    }
}

export const financeHierarchyListing = (page = 1, filterData = null) => async (dispatch) => {
    try {
        
        dispatch({
            type: FINANCE_HIERARCHY_LISTING,
            payload: null,
        });

        let url = `${Config.helpdeskUser.financeHierarchyList}?page=${page}`
        if(filterData !== null && Object.keys(filterData).length > 0){
            url = `${Config.helpdeskUser.financeHierarchyList}?page=${page}&status=${filterData?.status}&use_case_id=${filterData?.use_case_id}&request_id=${filterData?.request_id}&pi_no=${filterData?.pi_no}&ti_no=${filterData?.ti_no}&date=${filterData?.date}&requested_name=${filterData?.requested_name}&approver_l1=${filterData?.approver_l1}&approver_l2=${filterData?.approver_l2}`
        }

        const res = await callWebService(
            callTypes.get,
            {},
            url
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: FINANCE_HIERARCHY_LISTING,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: FINANCE_HIERARCHY_LISTING,
            payload: null,
        });
        return true;
    }
}

export const getSendBackToModificationRequest = (page = 1, filterData = null) => async (dispatch) => {
    try {

        dispatch({
            type: BACK_TO_MODIFICATION_REQUEST_LIST,
            payload: null,
        });

        let url = `${Config.helpdeskUser.backToModificationList}?page=${page}`
        if(filterData !== null && Object.keys(filterData).length > 0){
            url = `${Config.helpdeskUser.backToModificationList}?page=${page}&status=${filterData?.status}&use_case_id=${filterData?.use_case_id}&request_id=${filterData?.request_id}&pi_no=${filterData?.pi_no}&ti_no=${filterData?.ti_no}&date=${filterData?.date}&requested_name=${filterData?.requested_name}&approver_l1=${filterData?.approver_l1}&approver_l2=${filterData?.approver_l2}&department_name=${filterData?.department_name}&designation_name=${filterData?.designation_name}`
        }

        const res = await callWebService(
            callTypes.get,
            {},
            url
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: BACK_TO_MODIFICATION_REQUEST_LIST,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: BACK_TO_MODIFICATION_REQUEST_LIST,
            payload: null,
        });
        return true;
    }
}

export const csvDownload = (status, page = 1, filterData = null) => async (dispatch) => {
    try {

        dispatch({
            type: CSV_DOWNLOAD,
            payload: null,
        });

        let url = `${Config.helpdeskUser.csvDownload}?page=${page}&status=${status}`
        if(filterData !== null && Object.keys(filterData).length > 0){
            url = `${Config.helpdeskUser.csvDownload}?page=${page}&status=${status}&status=${filterData?.status}&use_case_id=${filterData?.use_case_id}&request_id=${filterData?.request_id}&pi_no=${filterData?.pi_no}&ti_no=${filterData?.ti_no}&date=${filterData?.date}&requested_name=${filterData?.requested_name}&approver_l1=${filterData?.approver_l1}&approver_l2=${filterData?.approver_l2}`
        }

        const res = await callWebService(
            callTypes.get,
            {},
            url
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: CSV_DOWNLOAD,
                payload: data?.response?.data,
            });
            return data?.response?.data;
        }
    }
    catch {
        dispatch({
            type: CSV_DOWNLOAD,
            payload: null,
        });
        return true;
    }
}












